import React, { Component } from "react";
import PropTypes from "prop-types";
import { findDOMNode } from "react-dom";
import { DragSource, DropTarget } from "react-dnd";
import ItemTypes from "./ItemTypes";

const targetItemSource = {
  beginDrag(props) {
    props.setDragging(props.id, props.indexa, props.indexb, false);
    return {
      id: props.id,
      type: ItemTypes.CARD,
      indexa: props.indexa,
      indexb: props.indexb
    };
  },
  isDragging(props, monitor) {
    return true;
  },
  endDrag(props) {
    props.setDragging(-1, -1, -1, false);
    props.cleanTargets();
  }
};

const cardTarget = {
  hover(props, monitor, component) {
    if (monitor.getItem().type === "search-card") {
      props.addTargetItem(monitor.getItem().target, props.indexa, props.indexb);
      monitor.getItem().type = "card";
      monitor.getItem().indexa = props.indexa;
      monitor.getItem().indexb = props.indexb;
      props.setDragging(monitor.getItem().id, props.indexa, props.indexb, true);
    } else {
      const dragIndexa = monitor.getItem().indexa;
      const dragIndexb = monitor.getItem().indexb;
      const hoverIndexa = props.indexa;
      const hoverIndexb = props.indexb;

      // Don't replace items with themselves
      if (dragIndexa === hoverIndexa && dragIndexb === hoverIndexb) {
        return;
      }

      // Determine rectangle on screen
      const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

      // Determine mouse position
      const clientOffset = monitor.getClientOffset();

      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;

      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%

      // Dragging downwards
      if (
        (dragIndexa < hoverIndexa ||
          (dragIndexa === hoverIndexa && dragIndexb < hoverIndexb)) &&
        hoverClientY < hoverMiddleY
      ) {
        return;
      }

      // Dragging upwards
      if (
        (dragIndexa > hoverIndexa ||
          (dragIndexa === hoverIndexa && dragIndexb > hoverIndexb)) &&
        hoverClientY > hoverMiddleY
      ) {
        return;
      }
      // Time to actually perform the action
      props.setDragging(monitor.getItem().id, hoverIndexa, hoverIndexb, null);
      props.moveTargetItem(dragIndexa, dragIndexb, hoverIndexa, hoverIndexb);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      monitor.getItem().indexa = hoverIndexa;
      monitor.getItem().indexb = hoverIndexb;
    }
  }
};

const drop = () =>
  DropTarget([ItemTypes.CARD, ItemTypes.SEARCHCARD], cardTarget, connect => ({
    connectDropTarget: connect.dropTarget()
  }));
const drag = () =>
  DragSource(ItemTypes.CARD, targetItemSource, (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging()
  }));
class SelectedTarget extends Component {
  static propTypes = {
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    indexa: PropTypes.number.isRequired,
    indexb: PropTypes.number.isRequired,
    isDragging: PropTypes.bool.isRequired,
    id: PropTypes.any.isRequired,
    target: PropTypes.any.isRequired,
    moveTargetItem: PropTypes.func.isRequired,
    cleanTargets: PropTypes.func.isRequired
  };

  render() {
    const {
      target,
      isDragging,
      connectDragSource,
      connectDropTarget
    } = this.props;

    const clsname = ["option", "bg-gray"];
    if ((isDragging || this.props.newTarget) && this.props.dragging) {
      clsname.push("option--hovered");
    }

    return connectDragSource(
      connectDropTarget(
        <div className={clsname.join(" ")}>
          <p className="option__label">
            {target.name}
          </p>
          <span className="option__tag">
            {target.type.replace(/_/g, " ")}
          </span>
          <div className="option__actions">
            <a
              onClick={() => this.props.removeTarget(target, this.props.indexa)}
              className="button--circular"
            >
              <i className="fa fa-times" />
            </a>
          </div>
        </div>
      )
    );
  }
}
export default drop()(drag()(SelectedTarget));



// WEBPACK FOOTER //
// ./src/components/SelectedTarget.js